import CustomizedSteppers from "../layouts/Stepper";
import TagInputs from "../layouts/TagInputs";
import upload from '../../assets/images/upload.png'
import OTP from "../layouts/OTP";
import { useEffect, useState } from "react";
import AboutLab from "../layouts/AboutLab";
import ContactPerson from "../layouts/ContactPerson";
import Partners from "../layouts/Partners";
import notification from "../../utility/notification";
import { get, post, put } from "../../utility/fetch";
import axios from "axios";
import { Box, Button, CircularProgress, IconButton, Typography } from "@mui/material";
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// import DeleteIcon from '@mui/icons-material/Delete';
import { FaCloudUploadAlt, FaTrash } from 'react-icons/fa';
import SetPassword from "../layouts/SetPassword";
import { useNavigate } from "react-router-dom";

const FileUploadSection = ({ label, width, file, onFileChange, onFileRemove, accept = "image/*" }) => {
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            p: 2,
            border: '1px dashed #ccc',
            borderRadius: 1,
            backgroundColor: '#f9f9f9',
            width: width,
            height: '200px',
            justifyContent: 'center'
        }}>
            {file ? (
                <>
                    <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
                        <img
                            src={typeof file === 'string' ? file : URL.createObjectURL(file)}
                            alt="Uploaded"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'contain',
                                borderRadius: '4px'
                            }}
                        />
                        <IconButton
                            onClick={onFileRemove}
                            sx={{
                                position: 'absolute',
                                top: 8,
                                right: 8,
                                backgroundColor: 'rgba(255,255,255,0.7)',
                                '&:hover': {
                                    backgroundColor: 'rgba(255,255,255,0.9)'
                                }
                            }}
                        >
                            <FaTrash color="error" />
                        </IconButton>
                    </Box>
                </>
            ) : (
                <label htmlFor={`upload-${label.toLowerCase().replace(/\s+/g, '-')}`}>
                    <input
                        id={`upload-${label.toLowerCase().replace(/\s+/g, '-')}`}
                        type="file"
                        accept={accept}
                        onChange={onFileChange}
                        style={{ display: 'none' }}
                    />
                    <Button
                        variant="outlined"
                        component="span"
                        startIcon={<FaCloudUploadAlt />}
                        sx={{ mb: 1, textWrap:'nowrap' }}
                    >
                        {label}
                    </Button>
                    {/* <Typography variant="caption" color="textSecondary">
                        Click to upload or drag and drop
                    </Typography> */}
                </label>
            )}
        </Box>
    );
};

const SignUp = () => {
    const [view, setView] = useState(0);
    const [states, setStates] = useState([]);
    const [lgas, setLgas] = useState([]);
    const [logoFile, setLogoFile] = useState(null);
    const [clinicPictureFile, setClinicPictureFile] = useState(null);
    const [certFile, setCertFile] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [otp, setOtp] = useState("");
    const [partnerPayload, setPartnerPayload] = useState(
        {
            hmoPartners: [
                {
                    healthCareProviderId: 0,
                    partnerName: "",
                    partnerType: "",
                    createdBy: 0
                }
            ],
            oemPartners: [
                {
                    healthCareProviderId: 0,
                    partnerName: "",
                    partnerType: "",
                    createdBy: 0
                }
            ],
            otherPartners: [
                {
                    healthCareProviderId: 0,
                    partnerName: "",
                    partnerType: "",
                    createdBy: 0
                }
            ]
        }
    );

    const [payload, setPayload] = useState(
        {
            name: "",
            location: "",
            dateEstablished: "",
            logoPath: "",
            cacPath: "",
            mandate: "",
            rcNumber: "",
            brandName: "",
            stateId: 0,
            lgaId: 0,
            phone: "",
            email: "",
            website: "",
            documents: [

            ]
        }
    );

    const [aboutLabPayload, setAboutLabPayload] = useState({
        healthCareProviderId: Number(localStorage.getItem("labId")),
        labDetails: "",
        workDays: "",
        workHours: "",
        thingToKnow: "",
        healthCareProviderPaymentOptions: []
    });

    const [contactPersonPayload, setContactPersonPayload] = useState({
        firstName: "",
        lastName: "",
        designation: "",
        phoneNumber: "",
        email: "",
        healthCareProviderId: Number(localStorage.getItem("labId"))
    });

    const navigate = useNavigate();

    const handleLogoChange = (event) => {
        const file = event.target.files[0]; // Get the selected file
        if (file) {
            setLogoFile(file); // Set the file to the state variable
            console.log("File selected:", file); // Optionally log the file for debugging
        }
    };

    const handleResendOtp = async () => {
        let res = await post('/healthcareprovider/resendotp', { email: payload?.email });
        if (res) {
            notification({ title: "Success", message: "OTP resent successfully", type: "success" });
            setOtp(""); // Clear the OTP input
        } else {
            notification({ title: "Error", message: "Failed to resend OTP", type: "danger" });
        }
    }


    const handleChangeOtp = (e) => {
        setOtp(e.target.value);
    };

    const handleSubmit = async (load) => {
        if (view === 0) {
            // Create healthcare provider
            let res = await post('/healthcareprovider/createhealthcareprovider', payload);
            if (res) {
                notification({ title: "Success", message: "Provider created successfully", type: "success" });
                localStorage.setItem('labId', res);
                setAboutLabPayload(prev => ({ ...prev, healthCareProviderId: res }));
                setContactPersonPayload(prev => ({ ...prev, healthCareProviderId: res }));
                setView(view + 1);
            } else {
                notification({ title: "Error", message: "Failed to create healthcare provider account", type: "danger" });
            }
        } else if (view === 2) {
            // Validate OTP
            let response = await get(`/healthcareprovider/validateotp?otp=${otp}&email=${payload?.email}`);
            if (response) {
                notification({ title: "Success", message: "OTP validated successfully", type: "success" });
                setView(view + 1);
            }
        } else if (view === -1) {
            // Submit About Lab
            let res = await post('/aboutlab', aboutLabPayload);
            if (res) {
                notification({ title: "Success", message: "About Lab saved", type: "success" });
                setView(view + 1);
            } else {
                notification({ title: "Error", message: "Failed to save About Lab", type: "danger" });
            }
        } else if (view === 1) {
            // Submit Contact Person
            let res = await post('/healthcareprovider/createhealthcareprovidercontactperson', contactPersonPayload);
            if (res) {
                notification({ title: "Success", message: "Contact Person saved successfully, Please check your email for a 4-digit OTP", type: "success" });
                setView(view + 1);
            } else {
                notification({ title: "Error", message: "Failed to save Contact Person", type: "danger" });
            }
        } else if (view === 3) {
            // Set Password
            let res = await put(`/auth/change-employee-password/${payload?.email}`, {password: load})
            if(res?.statusCode === 200){
                notification({ title: "Success", message: res?.data?.message, type: "success" });
                navigate("/")
            }
        }
        // setView(view + 1)
    }
    const handleClinicPictureChange = (event) => {
        const file = event.target.files[0]; // Get the selected file
        if (file) {
            setClinicPictureFile(file); // Set the file to the state variable
            console.log("File selected:", file); // Optionally log the file for debugging
        }
    };

    const handleCertChange = (event) => {
        const file = event.target.files[0]; // Get the selected file
        if (file) {
            setCertFile(file); // Set the file to the state variable
            console.log("File selected:", file); // Optionally log the file for debugging
        }
    };


    const handleChange = (event) => {
        const { name, value } = event.target;
        // else if (name === "dateOfBirth") {
        //   const selectedDate = new Date(value);
        //   const currentDate = new Date();

        //   if (selectedDate >= currentDate) {
        //     notification({ message: 'Date selected cannot be a future date', type: "error" });
        //     return;
        //   }
        // } else if (name === 'phoneNumber') {
        //   if ((value.length <= 11 && isNaN(value)) || value.length > 11) {
        //     notification({ message: 'Please enter a valid phone number', type: "error" });
        //     return;
        //   }
        // }

        setPayload(prevPayload => ({ ...prevPayload, [name]: value }));
    };

    const handleSubmitPassword = async (password) =>{
        let res = await put(`/auth/change-employee-password/${payload?.email}`, {password})
        console.log(res);
        if(res?.statusCode === 200){
            notification({ title: "Success", message: res?.data?.message, type: "success" });
            navigate("/login")
        }
    }


    const handleSelectChange = (e, name) => {
        console.log(e)
        if (name === 'state') {
            setPayload(prevPayload => ({ ...prevPayload, stateId: Number(e?.value) }));
            getLgas(Number(e?.value));
            return;
        }
        else if (name === 'lga') {
            setPayload(prevPayload => ({ ...prevPayload, lgaId: Number(e?.value) }));
            return;
        }
    }


    useEffect(() => {
        getStates()
    }, [])


    const getStates = async () => {
        try {
            const response = await get(`/healthcareprovider/getstates`);

            setStates([{ label: "Select State", value: 0 },
            ...response.map((state) => ({
                label: state?.state,
                value: state?.id,
            }))])

        } catch (error) {
            console.error("Error fetching states:", error);
        }
    };


    const getLgas = async (id) => {
        let response = await get(`/healthcareprovider/getlgasbystateid/id/${id}`);

        setLgas([{ label: "Select Lga", value: 0 },
        ...response.map((lga) => ({
            label: lga?.lga,
            value: lga?.id,
        }))])
    }

    const FileUpload = async (data, callbackfunction, type) => {
        let fileProgress;
        let Access_token = sessionStorage.getItem('token');
        const response = axios.post(
            `${process.env.REACT_APP_BASE_URL}/services/api/documents/clinic-admin`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${Access_token}`,
                    "content-type": "multipart/form-data",
                    'content-type': undefined,
                },
                onUploadProgress: (progressEvent) => {
                    const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                    setUploadProgress(progress);
                },
            },
        );
        await response
            .then((response) => {
                let result = response.data;
                callbackfunction(result);
                setUploadProgress(0);
                console.log(response);
                if (type === "clinicPhoto") {
                    setClinicPictureFile(response?.data?.doclink)
                    setPayload((prev) => ({ ...prev, documents: [{ docPath: response?.data?.doclink, docName: "clicic Logo" }] }))
                }
                else if (type === "cert") {
                    setCertFile(response?.data?.doclink)
                    setPayload((prev) => ({ ...prev, cacPath: response?.data?.doclink }))
                }
                else {
                    setLogoFile(response?.data?.doclink)
                    setPayload((prev) => ({ ...prev, logoPath: response?.data?.doclink }))
                }
            })
            .catch((error) => {
                callbackfunction(error);

            });
    };

    const handleImage = (e, f) => {
        console.log(e)
        const data = new FormData();
        const supportedTypes = [
            'jpeg',
            'png',
            'gif',
            'pdf',
            "msword",
            "ppt", "pptx", "vnd.ms-excel", "xls", "xlsx",
            'vnd.openxmlformats-officedocument.wordprocessingml.document',
            'doc',
            'vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ];
        const { type, size } = e.target.files[0] ?? '';

        let doc = e.target.files[0];

        const fileType = type.slice(type.indexOf('/') + 1);

        let defObj = {
            docTitle: '',
            docPath: ''
        };

        if (!supportedTypes.includes(fileType)) {
            notification({
                title: "Upload Error",
                message: "Unsopported file type",
                type: "danger"
            })
        }

        if (supportedTypes.includes(fileType) && size / 1024 < 500000) {
            data.append('files', doc);
            FileUpload(data, (response) => {
                if (response.code === 1) {
                    // defObj.docTitle = doc.name;
                    // defObj.docPath = response.doclink;
                    // props.sendImagg && props.sendImagg(defObj);
                } else if (response.code === 0) {
                    notification({
                        title: "Upload Error",
                        message: response?.message,
                        type: "danger"
                    })

                } else {
                    notification({
                        title: "Upload Error",
                        message: response?.message,
                        type: "danger"
                    })

                }
            }, f);
        }
    };


    const fetchStates = async () => {
        const token = sessionStorage.getItem('token');
        if (!token) {
            notification({ message: 'Token not found in session storage', type: "error" });
            return;
        }

        const options = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };

        try {
            let res = await axios.get(`${process.env.REACT_APP_BASE_URL}/clinicapi/api/profile/state/list/1/100`, options);
            let tempDoc = res?.data?.resultList.map((doc) => {
                return { name: doc?.name, value: doc?.name };
            });

            tempDoc?.unshift({ name: "Select State", value: "" });
            setStates(tempDoc);
        } catch (error) {
        }
    };


    const handleFileUpload = async (file, type) => {
        if (!file) return;

        const data = new FormData();
        data.append('files', file);

        try {
            const Access_token = sessionStorage.getItem('token');
            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/services/api/documents/clinic-admin`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${Access_token}`,
                        "content-type": "multipart/form-data",
                    },
                    onUploadProgress: (progressEvent) => {
                        const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                        setUploadProgress(progress);
                    },
                }
            );

            const result = response.data;

            if (type === "clinicPhoto") {
                setClinicPictureFile(result.doclink);
                setPayload(prev => ({
                    ...prev,
                    documents: [{ docPath: result.doclink, docName: "clinic Logo" }]
                }));
            } else if (type === "cert") {
                setCertFile(result.doclink);
                setPayload(prev => ({ ...prev, cacPath: result.doclink }));
            } else {
                setLogoFile(result.doclink);
                setPayload(prev => ({ ...prev, logoPath: result.doclink }));
            }

            notification({
                title: "Success",
                message: "File uploaded successfully",
                type: "success"
            });

        } catch (error) {
            console.error("Upload error:", error);
            notification({
                title: "Upload Error",
                message: error.response?.data?.message || "Failed to upload file",
                type: "danger"
            });
        } finally {
            setUploadProgress(0);
        }
    };


    const handleFileChange = (event, type) => {
        const file = event.target.files[0];
        if (!file) return;

        const supportedTypes = ['image/jpeg', 'image/png', 'image/gif', 'application/pdf'];
        const fileType = file.type;

        if (!supportedTypes.includes(fileType)) {
            notification({
                title: "Upload Error",
                message: "Unsupported file type",
                type: "danger"
            });
            return;
        }

        if (file.size > 5 * 1024 * 1024) { // 5MB limit
            notification({
                title: "Upload Error",
                message: "File size exceeds 5MB limit",
                type: "danger"
            });
            return;
        }

        handleFileUpload(file, type);
    };


    const handleFileRemove = (type) => {
        if (type === "clinicPhoto") {
            setClinicPictureFile(null);
            setPayload(prev => ({
                ...prev,
                documents: prev.documents.filter(doc => doc.docName !== "clinic Logo")
            }));
        } else if (type === "cert") {
            setCertFile(null);
            setPayload(prev => ({ ...prev, cacPath: "" }));
        } else {
            setLogoFile(null);
            setPayload(prev => ({ ...prev, logoPath: "" }));
        }
    };

    return (
        <div style={{ height: "100vh" }} className={`signupbanner p-40`}>
            <div className="p-t-20">
                <CustomizedSteppers step={view} />
            </div>

            {view === 0 && <div>
                <h3 className="center-text m-t-10">Hey, Welcome to ConnectHealthPro Labs</h3>
                <div className="flex flex-h-center p-20">
                    <div className="flex-30">
                        <div className="w-90">
                            <TagInputs onChange={handleChange} name="name" label="Company Name" />
                            <TagInputs onChange={handleChange} name="rcNumber" label="RC Number" />
                            <TagInputs onChange={handleChange} name="brandName" label="Brand Name" />
                            <TagInputs onChange={handleChange} name="location" label="Lab Address" />
                            <TagInputs onChange={(e) => handleSelectChange(e, "state")} options={states} type="R-select" name="stateId" label="State" />
                            <TagInputs onChange={(e) => handleSelectChange(e, "lga")} options={lgas} type="R-select" name="lgaId" label="LGA" />
                            <TagInputs onChange={handleChange} name="phone" label="Telephone" />
                            <TagInputs onChange={handleChange} name="email" label="Email Address" />
                            <TagInputs onChange={handleChange} name="website" label="Website" />
                            {/* <TagInputs onChange = {handleChange} label="Social Media" /> */}
                            <TagInputs onChange={handleChange} type="date" name="dateEstablished" label="Commencement Date" />
                        </div>

                        {/* <div className="flex space-between w-90 m-t-20">
                            <button className="submit-btn flex-40">
                                Save
                            </button>
                            <button onClick={() => setView(view + 1)} className="btn flex-40">
                                Continue
                            </button>
                        </div> */}
                    </div>

                    <div className="flex-20 flex-0 m-t-10">

                        <div className="flex space-between m-t-20">
                            <div className="flex-20 m-t-10" style={{ gap: '20px', display: 'flex', flexDirection: 'column' }}>
                                <FileUploadSection
                                    label="Upload Clinic Picture"
                                    file={clinicPictureFile}
                                    width={"400px"}
                                    onFileChange={(e) => handleFileChange(e, "clinicPhoto")}
                                    onFileRemove={() => handleFileRemove("clinicPhoto")}
                                />

                                <Box sx={{ display: 'flex', gap: '10px' }}>
                                    <Box sx={{ flex: 1 }}>
                                        <FileUploadSection
                                            label="Client Logo"
                                            file={payload?.logoPath}
                                            width={"200px"}
                                            onFileChange={(e) => handleFileChange(e, "logo")}
                                            onFileRemove={() => handleFileRemove("logo")}
                                        />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <FileUploadSection
                                            label="Certificate"
                                            file={payload?.cacPath}
                                            width={"200px"}
                                            onFileChange={(e) => handleFileChange(e, "cert")}
                                            onFileRemove={() => handleFileRemove("cert")}
                                            // accept=".pdf,.doc,.docx"
                                        />
                                    </Box>
                                </Box>

                                {uploadProgress > 0 && (
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <CircularProgress variant="determinate" value={uploadProgress} size={20} />
                                        <Typography variant="body2">
                                            Uploading: {uploadProgress}%
                                        </Typography>
                                    </Box>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* <div className="flex-30">

                </div> */}

                </div>
            </div>
            }


            {
                view === -1 &&
                <div className="flex flex-h-center flex-v-center m-t-20">
                    <AboutLab
                        aboutLabPayload={aboutLabPayload}
                        setAboutLabPayload={setAboutLabPayload}
                        handleSubmit={handleSubmit}
                        setView={setView}
                    />
                </div>
            }

            {
                view === 1 &&
                <div className="flex flex-h-center flex-v-center m-t-20">
                    <ContactPerson
                        contactPersonPayload={contactPersonPayload}
                        setContactPersonPayload={setContactPersonPayload}
                        handleSubmit={handleSubmit}
                        setView={setView}
                    />
                </div>
            }

             {/* {
                view === 3 &&
                <div className="flex flex-h-center flex-v-center m-t-20">
                    <Partners
                        partnerPayload={partnerPayload}
                        setPartnerPayload={setPartnerPayload}
                        handleSubmit={handleSubmit}
                        setView={setView}
                    />
                </div>
            } */}

            
            {
                view === 2 &&
                <div className="flex flex-direction-v flex-h-center flex-v-center m-t-40">
                    <OTP handleSubmit={handleSubmit} handleChangeOtp={handleChangeOtp} handleResendOtp={handleResendOtp} setView={setView} />
                    {/* <div className="flex  w-40 m-t-20">
                        <button className="submit-btn flex-30 m-r-10">
                            Save
                        </button>
                        <button onClick={() => setView(view + 1)} className="btn flex-30">
                            Continue
                        </button>
                    </div> */}
                </div>

            }

            {
                view === 3 &&
                <div className="flex flex-h-center flex-v-center m-t-20">
                    <SetPassword
                        payload={payload}
                        aboutLabPayload={aboutLabPayload}
                        setAboutLabPayload={setAboutLabPayload}
                        onSubmitPassword={handleSubmitPassword}
                        setView={setView}
                    />
                </div>
            }

            <div className="flex flex-h-center">
                <div className="flex flex-h-center w-60 flex-direction-v w-100 m-t-10 m-b-40">
                    <div className="flex flex-40 flex-h-center">
                        <button className="submit-btn flex-30 m-r-10">
                            {view < 2 ? `Save` : `Preview provide Information`}
                        </button>
                        <button onClick={handleSubmit} className="btn flex-30">
                            {view < 2 ? `Continue` : `Submit Form`}
                        </button>
                    </div>
                    {view > 0 && <div className="flex flex-40 flex-h-center m-t-20">
                        <button onClick={() => setView((prev) => prev - 1)} className="submit-btn flex-30 m-r-10">
                            {`Go Back`}
                        </button>
                    </div>}

                </div>
            </div>



        </div>
    )
}
export default SignUp;